import { CSSProperties, useEffect, useRef, useState } from 'react';

import Range from '@/libs/slider/src/Range';

interface RangeSelectLogProps {
  onChange?: Nullable<(values: [number, number]) => void>;
  marks: Record<number, StringOrNumber>;
  marksStyles?: Nullable<Record<string, CSSProperties>>;
  valueMin?: Nullable<number>;
  valueMax?: Nullable<number>;
  step?: Nullable<number>;
  withTips?: boolean;
}

// TODO styles are missed in this component, they must be imported from RangeSelect
function RangeSelectLog(props: RangeSelectLogProps) {
  const {
    onChange = null,
    marks,
    marksStyles = null,
    valueMin: valueMinProp = 0,
    valueMax: valueMaxProp = 0,
    step = null,
  } = props;

  const allCount = Object.keys(marks).length;
  const min = 0;
  const max = allCount - 1;

  const [valueMin, setValueMin] = useState(valueMinProp || min);
  const [valueMax, setValueMax] = useState(valueMaxProp || max);

  const isFirstRenderRef = useRef(true);

  useEffect(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;

      return;
    }

    let nextValueMin = valueMinProp || min;
    let nextValueMax = valueMaxProp || max;

    if (nextValueMin && nextValueMax && nextValueMin > nextValueMax) {
      [nextValueMin, nextValueMax] = [nextValueMax, nextValueMin];
    }

    setValueMin(nextValueMin);
    setValueMax(nextValueMax);
  }, [valueMinProp, valueMaxProp]);

  function handleChange(values: [number, number]) {
    let [nextValueMin, nextValueMax] = values;

    if (nextValueMin && nextValueMax && nextValueMin > nextValueMax) {
      [nextValueMin, nextValueMax] = [nextValueMax, nextValueMin];
    }

    setValueMin(nextValueMin);
    setValueMax(nextValueMax);
  }

  function handleAfterChange(values: [number, number]) {
    let [nextMinValue, nextMaxValue] = values;

    if (nextMinValue && nextMaxValue && nextMinValue > nextMaxValue) {
      [nextMinValue, nextMaxValue] = [nextMaxValue, nextMinValue];
    }

    setValueMin(nextMinValue);
    setValueMax(nextMaxValue);

    if (onChange) {
      onChange([nextMinValue, nextMaxValue]);
    }
  }

  return (
    <Range
      min={min}
      max={max}
      marks={marks}
      marksStyles={marksStyles}
      step={step}
      onChange={handleChange}
      onAfterChange={handleAfterChange}
      value={[valueMin, valueMax]}
    />
  );
}

export default RangeSelectLog;
